import { TFunction } from "i18next";
import * as yup from "yup";

export interface KnowledgeCheckValidationSchemeProps {
  t: TFunction;
}

export const KnowledgeCheckValidationScheme = ({
  t,
}: KnowledgeCheckValidationSchemeProps) => {
  const requiredMsg = t("validations.required");

  return yup.object().shape({
      name: yup.string().required(requiredMsg)
  });;
};